module.exports = __webpack_public_path__ + "static/img/tuzheng_03.5e33380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuzheng_03.png
// module id = l4lR
// module chunks = 1